import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { PageTitle as CommonPageTitle } from '@termly-web/common'

// TODO: There are a lot of places all over the site where we use AutoFormattedMessage
// for the page title. Those cases should be replaced with this component, but I'm not
// doing that now because I need this to be a precision fix for TER-9026 (I went down
// that road and it got too hairy too fast for the amount of time I now have).


export default function PageTitle({ className, title, values }) {
  // Sometimes, the values for `title` are passed as a separate prop. In other cases,
  // it's more convenient to pass them along part of the `title` object itself.
  // Here, we're supporting both cases, and we'll consider an explicit `values` prop
  // to be an override of whatever may be in `title`.
  const message = {
    ...title,
    values: {
      ...title.values,
      ...values,
    },
  }

  return (
    <CommonPageTitle className={ className }>
      <FormattedMessage
        { ...message }
      />
    </CommonPageTitle>
  )
}

PageTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.shape(FormattedMessage.propTypes),
  values: PropTypes.shape({}),
}
